var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWbm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_wbm",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1667",
    "data-name": "Rectangle 1667",
    width: 23.625,
    height: 23.625,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1681",
    "data-name": "Rectangle 1681",
    width: 42,
    height: 42,
    fill: "#6639b7",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_wbm-2",
    "data-name": "icon_wbm",
    transform: "translate(9.188 9.188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3707",
    "data-name": "Groupe 3707",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13542",
    "data-name": "Trac\\xE9 13542",
    d: "M1.259,22.779a3.577,3.577,0,0,0,5.034-.414l5.393-6.372.48.189A8.384,8.384,0,0,0,23.36,6.3.587.587,0,0,0,23.187,6a.564.564,0,0,0-.425-.156.6.6,0,0,0-.414.192L18.07,10.694,14.307,9.308,12.933,5.561,17.588,1.28a.63.63,0,0,0,.176-.294A.6.6,0,0,0,17.7.538a.59.59,0,0,0-.365-.271A8.461,8.461,0,0,0,15.236,0,8.391,8.391,0,0,0,7.443,11.462l.189.48L1.259,17.336a3.563,3.563,0,0,0,0,5.443",
    transform: "translate(0 0.001)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWbm);
export default __webpack_public_path__ + "static/media/icon_wbm.6a9a73b97115b71f283125d897076baf.svg";
export { ForwardRef as ReactComponent };